import { notifyInStackDetailPage } from "@mirage/service-fss-bridge";
import {
  activeStackAtom,
  activeStackItemShortcutsAtom,
} from "@mirage/stacks/atoms";
import { stackChatSidebarOpenAtom } from "@mirage/stacks/atoms/chatSidebarAtoms";
import {
  convertItemsToFSSFiles,
  useLoadDashStackChat,
} from "@mirage/stacks/hooks/useStackChat";
import { isFssStack } from "@mirage/stacks/utils";
import { useAtom, useAtomValue } from "jotai";
import { useCallback } from "react";

export function useNotifyInStackDetailPage() {
  const stack = useAtomValue(activeStackAtom);
  const items = useAtomValue(activeStackItemShortcutsAtom);
  const [isStackChatSidebarOpen, setStackChatSidebarOpen] = useAtom(
    stackChatSidebarOpenAtom,
  );
  const loadDashStackChat = useLoadDashStackChat();
  return useCallback(
    (shareId: string, stackName?: string, isChatEnabled?: boolean) => {
      if (!isFssStack(stack)) {
        // For Dash stack, if chat sidebar is open, update the scope to the stack
        if (isStackChatSidebarOpen) {
          setStackChatSidebarOpen(true);
          loadDashStackChat();
        }
      }

      const fileIds = items ? convertItemsToFSSFiles(items) : [];
      notifyInStackDetailPage(shareId, stackName, isChatEnabled, fileIds);
    },
    [
      stack,
      items,
      isStackChatSidebarOpen,
      setStackChatSidebarOpen,
      loadDashStackChat,
    ],
  );
}
